export default "__VITE_ASSET__d5fffc7c__"